<template>
  <div>
    <v-fade-transition>
      <v-snackbar
          v-if="snacks.length > 0"
          :key="snack.id"
          :value="snack.show"
          @input="remove(snack)"
          :timeout="snack.permanent ? -1 : timeout"
          :left="!$vuetify.breakpoint.mobile"
          bottom
          :color="snack.type"
      >
        <template v-slot:default>
          {{snack.message}}
        </template>
        <template v-slot:action>
          <v-btn v-if="snack.action"
                 color="accent"
                 text
                 @click="snack.action.handler(snack)">
            {{snack.action.title}}
          </v-btn>
          <v-btn v-else icon @click="snack.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-fade-transition>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import { SNACKS_DEFAULT_MILLIS } from '../constants';

  export default {
    name: "Snacks",
    data: () => ({
      timeout: SNACKS_DEFAULT_MILLIS,
    }),
    computed: {
      ...mapState('snackbars', ['snacks']),
      snack() {
        return this.snacks[this.snacks.length - 1];
      },
    },
    methods: mapActions('snackbars', ['remove']),
  }
</script>

<style scoped>
  .mobile-snack {
    bottom: 0;
    left: 0;
    right: 0;
  }

</style>
